<template>
  <div>
    <footer class="footer">
      <div class="container">
		<p><a href="#" class="btn btn-outline-light btn-block"><strong>GLOBAL PARTNERSHIP ON MARINE LITTER <strong class="text-primary">[GPML]</strong></strong></a></p>
		<p><strong>This is a multi-stakeholder platform that brings together all actors working to prevent marine litter and microplastics by providing a unique avenue to share knowledge and experience, partners are able to work together to create and advance solutions to this pressing global issue.</strong></p>
       <ul class="menu text-center">
		   <li class="active"><a href="#">Home</a></li>
		   <li><a href="#">About</a></li>
		   <li><a href="#">Action Plans</a></li>
		   <li><a href="#">Projects</a></li>
		   <li><a href="#">Resources</a></li>
		</ul>
		<div class="site-info text-center">
			<p><strong>Global Partnership on Maarine Litter Secretariat <br> United Nations Enviroment Programme <br> UN Avenue, Nairobi. Email: <a href="mail:secretariat@gpmarinelitter.org">secretariat@gpmarinelitter.org</a></strong></p>
		</div>
		<div class="footer-social text-center">
			<ul class="list-inline">
			   <li> <a href="#"> <i class="icon-social-twitter"></i> </a> </li>
			   <li> <a href="#"> <i class="icon-social-facebook"></i> </a> </li>
			   <li> <a href="#"> <i class="icon-social-youtube"></i> </a> </li>
			   <li> <a href="#"> <i class="icon-social-dribbble"></i> </a> </li>
			</ul>
		  </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>



// WEBPACK FOOTER //
// src/elements/Footer.vue